<template lang="html">
  <div class="contactus">
    <h1 class="display-1">Kapcsolat</h1>
    <div class="infogroup">
      <h3>Menhely kapcsolattartója,vezetője</h3>
      <p>Ügyes Boglárka</p>
    </div>

    <div class="infogroup">
      <h3>Telephely</h3>
      <p>Nagyhegység, Boglárka u .1.</p>
    </div>

    <div class="infogroup">
      <h3>Telefon, fax</h3>
      <p>+3612345678</p>
    </div>

    <div class="infogroup">
      <h3>Elektronikus elérhetőségek</h3>
      <p>
        <span>emailcímunk@email.hu</span>
        <a href="#" target="_blank">ezazoldal.hu</a>
        <a href="#" target="_blank">facebookoldalunk.com</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
  .contactus{
    width: 95%;
    margin: 10px auto;
    text-align: center;
  }

  h1{
    margin-bottom: 20px;
  }

  .infogroup h3{
    color: $darkbrown;
    font-weight: bold;
  }

  .infogroup a,
  .infogroup span{
    display: block;
    text-decoration: none;
  }
</style>
